import React from 'react';
import { useGetUpcomingCoachingAndTherapyAppointments } from 'Book';
import {
  PractitionerBookingStep,
  usePractitionerBookingOptions,
} from '../hooks/usePractitionerBookingOptions';
import { useSectionErrorLogging } from '../hooks/useSectionErrorLogging';
import { BookPractitionerItem } from './BookPractitionerItem';
import { PractitionerMatchingItem } from './PractitionerMatchingItem';
import { SessionPrepItem } from './SessionPrepItem';
import { SkeletonItem } from './SkeletonItem';

export const TherapyAndCoachingItem = () => {
  const {
    loading: appointmentsLoading,
    error: appointmentsError,
    apolloError: error,
    data: { upcomingEvents, upcomingEventRequests, userID },
  } = useGetUpcomingCoachingAndTherapyAppointments();
  useSectionErrorLogging(error, upcomingEvents, 'todo-list');

  const nextSession = upcomingEvents?.[0];
  const hasPendingRequest = Boolean(upcomingEventRequests?.length);
  const {
    isLoading: isBookingOptionsLoading,
    step,
    remaining,
  } = usePractitionerBookingOptions({
    skipMatches:
      appointmentsLoading || Boolean(nextSession) || hasPendingRequest,
  });

  if (appointmentsLoading) {
    return <SkeletonItem />;
  }

  if (Boolean(appointmentsError) || !userID) {
    return null;
  }

  if (nextSession) {
    return <SessionPrepItem session={nextSession} userID={userID} />;
  }

  if (hasPendingRequest) {
    return null;
  }

  if (isBookingOptionsLoading) {
    return <SkeletonItem />;
  }

  if (step === PractitionerBookingStep.Match) {
    return <PractitionerMatchingItem remaining={remaining} />;
  }

  if (step === PractitionerBookingStep.Book) {
    return <BookPractitionerItem remaining={remaining} />;
  }

  return null;
};
